import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  helpdeskMain: {
    maxHeight: '55px',
    backgroundColor: 'white',
    border: '1px solid #d7d7dc',
    borderRadius: '5px',
    margin: '10px 0px',
    display: 'flex',
    justifyContent: 'space-between',
  },

  helpdeskMainContainer: {
    width: '70%',
    justifyContent: 'left',
    display: 'flex',
    fontFamily: 'Roboto'
  },

  helpdeskPicImg: {
    margin: '12px',
    maxHeight: '55%',
    maxWidth: '55%',
  },

  helpdeskInfoContainer: {
    margin: '8px',
  },

  helpdeskInfoTitle: {
    margin: '0',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },

  helpdeskInfoSize: {
    fontSize: '12px',
  },

  helpdeskButtonsContainer: {
    display: 'flex',
    marginRight: '20px',
    alignItems: 'center',
    color: '#3560ff',
    fontWeight: 'bold',
  },

  helpdeskEditIcon: {
    marginRight: '10px',
    cursor: 'pointer',
  },

  helpdeskDeleteIcon: {
    cursor: 'pointer',
  },

  helpdeskButtonView: {
    borderColor: 'white',
    fontWeight: 'bold',
    cursor: 'pointer',
    backgroundColor: 'white',
    borderStyle: 'solid',
    marginLeft: '-7px',
    fontFamily: 'Roboto'
  },

  helpdeskPopover: {
    '& p': {
      padding: '10px 0px',
    },
  },

  helpdeskButtonsPopoverContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 20px 10px 5px',

    '&:hover *': {
      backgroundColor: '#f4f4fe',
    },
    '&:hover': {
      backgroundColor: '#f4f4fe',
    },
    cursor: 'pointer'
  },

  helpdeskButton: {
    margin: 0,
    borderColor: 'white',
    cursor: 'pointer',
    backgroundColor: 'white',
    borderStyle: 'none',
  },

  helpdeskButtonSpan: {
    display: 'inline-block',
    marginRight: '20px',
    marginLeft: '5px',
  },
}));

export { useStyles };
